import React from 'react';

const SearchIconFillable = ({ fill = 'currentColor', title }) => {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        aria-hidden="true"
        focusable="false">
        <title>{title}</title>
        <path className="search-icon" fill={fill} fillRule="evenodd" d="M12.502 11h-.794l-.276-.274A6.47 6.47 0 0 0 13 6.5 6.5 6.5 0 1 0 6.5 13a6.47 6.47 0 0 0 4.225-1.566l.276.274v.792l4.998 4.991L17.49 16l-4.988-5zM6.5 11a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9z" />
      </svg>
  );
};

export default SearchIconFillable;
